import React, { useEffect, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById('hero-cta');
    if (!anchor) return;
    const observer = new IntersectionObserver(([entry]) => {
      // Show once the hero CTA has scrolled out of view upward.
      setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
    }, {
      threshold: 0
    });
    observer.observe(anchor);
    return () => observer.disconnect();
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-40 px-3 pb-3 transition-[opacity,transform] duration-200 ease-out ${visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-6 opacity-0'}`} data-id="element-35" data-mp="2fstl9170z96z">
      <div className="mx-auto max-w-md" data-id="element-36" data-mp="33k8s979qyeok">
        <a href={CHECKOUT_URL} className="flex animate-shake items-center justify-center gap-2 rounded-2xl bg-clinic-500 px-4 py-3.5 text-center text-sm font-black uppercase leading-tight tracking-tight text-white shadow-[0_8px_24px_rgba(6,18,37,0.35)] transition-colors duration-150 ease-out hover:bg-clinic-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-navy-900 sm:text-base" data-id="element-37" data-mp="33j7cwqlp7611">
          Get access — $27 USD
          <ArrowRightIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-38" data-mp="2fcx45aeuqlr7" />
        </a>
        <p className="mt-1.5 text-center text-[10px] font-semibold uppercase tracking-wide text-navy-600" data-id="element-39" data-mp="2kdbex07u89sx">
          One-time payment • 7-day guarantee
        </p>
      </div>
    </div>;
}